import { render, staticRenderFns } from "./SummaryRegister.vue?vue&type=template&id=b7119b66&"
import script from "./SummaryRegister.vue?vue&type=script&lang=js&"
export * from "./SummaryRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports